import ButtonGroup from '@material-ui/core/ButtonGroup'

const Admin = ({ fragments }) => {
  const [cookies] = useCookies(['neu_nclb_admin'])

  return cookies['neu_nclb_admin'] ? (
    <Grid item xs={12}>
      <ButtonGroup color="secondary" fullWidth variant="contained" disableElevation>
        <Button href={`/admin/fragment/${fragments['action_email_subject'].id}/edit`}>
          [Admin] Edit subject
        </Button>
        <Button href={`/admin/fragment/${fragments['action_email_body'].id}/edit`}>
          [Admin] Edit body
        </Button>
      </ButtonGroup>
    </Grid>
  ) : (
    <></>
  )
}

export default Admin
